export const productDevelopmentDashboardDe = {
  title: 'Produktentwicklung',
  subtitle: 'Rollenabhängige Übersicht über Stammdaten, Freigaben, Produktion und Planung.',
  help: 'Hilfe zur Produktentwicklung öffnen',
  refresh: 'Dashboard aktualisieren',
  generatedAt: 'Datenstand {{date}}',
  loading: {
    title: 'Produktentwicklungs-Dashboard wird geladen',
    description: 'Die aktuellen Workflow- und Planungssignale werden berechnet.',
  },
  error: {
    title: 'Dashboard konnte nicht geladen werden',
    description: 'Der Server konnte die aktuellen Produktentwicklungssignale nicht berechnen.',
    retry: 'Erneut versuchen',
  },
  empty: {
    title: 'Keine rollenbezogenen Kennzahlen verfügbar',
    description: 'Ihre Rolle besitzt derzeit kein Leserecht für die Datenbereiche des Dashboards.',
  },
  cards: {
    OPEN_WORKFLOWS: {
      title: 'Offene Prüfungen und Freigaben',
      description: 'Vorgänge, die eine ausdrückliche fachliche Entscheidung benötigen.',
    },
    INCOMPLETE_MATERIALS: {
      title: 'Unvollständige Rohstoffe',
      description: 'Neueste Profile ohne Freigabe, Lieferantendaten oder Deklarationsnamen.',
    },
    DECLARATION_WARNINGS: {
      title: 'Deklarationswarnungen',
      description: 'Neueste Deklarationen mit Fehlern, Abweichungen oder fehlenden Sprachen.',
    },
    EXPIRING_VERSIONS: {
      title: 'Auslaufende Versionen',
      description: 'Freigegebene Quellversionen, die innerhalb von 30 Tagen auslaufen.',
    },
    UPCOMING_PRODUCTION_ORDERS: {
      title: 'Anstehende Produktionsaufträge',
      description: 'Geplante oder freigegebene Aufträge mit Start innerhalb von 14 Tagen.',
    },
    MATERIAL_SHORTAGES: {
      title: 'Materialfehlmengen',
      description: 'Offene Vorschläge aus dem neuesten reproduzierbaren MRP-Lauf.',
    },
    PRODUCTION_DEVIATIONS: {
      title: 'Produktionsabweichungen',
      description: 'Jüngste Fertigmeldungen mit exakter Ausbeute- oder Verbrauchsdifferenz.',
    },
  },
  workflows: {
    title: 'Prüfungen und Freigaben',
    subtitle: 'Es erscheinen nur Warteschlangen für Aktionen, die Ihre Rolle ausführen darf.',
    review: 'Prüfung',
    approval: 'Freigabe',
    open: 'Warteschlange öffnen',
    none: 'Ihrer Rolle sind keine ausführbaren Workflow-Warteschlangen zugeordnet.',
  },
  queues: {
    MATERIALS: 'Materialprofile',
    RECIPES: 'Rezepturen und BOMs',
    PROCESS_ROUTINGS: 'Arbeitspläne',
    DECLARATIONS: 'Deklarationen',
    ANALYSIS: 'Analyseprofile',
    SPECIFICATIONS: 'Produktspezifikationen',
    LABELS: 'Etikettenvorlagen',
    CHANGE_REQUESTS: 'Änderungsanträge',
  },
  recentRecipes: {
    title: 'Zuletzt geänderte Rezepturen',
    subtitle: 'Je sichtbarer Rezeptur wird die zuletzt bearbeitete Version angezeigt.',
    empty: 'Es sind keine Rezepturversionen vorhanden.',
    number: 'Nummer',
    name: 'Rezeptur',
    product: 'Ausgabeartikel',
    version: 'Version',
    status: 'Status',
    changed: 'Geändert',
    open: 'Rezeptur {{number}} öffnen',
  },
  deviations: {
    title: 'Ausbeute- und Verbrauchsabweichungen',
    subtitle: 'Jüngste Fertigmeldungen; Prozente werden serverseitig dezimalgenau berechnet.',
    empty: 'Im aktuellen 30-Tage-Zeitraum wurden keine Differenzen erfasst.',
    order: 'Auftrag',
    product: 'Artikel',
    plannedActual: 'Soll / Ist',
    yield: 'Ausgabeabweichung',
    material: 'Größte Materialabweichung',
    reported: 'Gemeldet',
    unbounded: 'Unbegrenzt (Verbrauch bei Sollmenge null)',
    open: 'Produktionsauftrag {{number}} öffnen',
  },
  recipeStatuses: {
    DRAFT: 'Entwurf',
    IN_REVIEW: 'In Prüfung',
    APPROVED: 'Freigegeben',
    BLOCKED: 'Gesperrt',
    ARCHIVED: 'Archiviert',
  },
} as const;
